import gql from 'graphql-tag';
import { apollo } from 'src/features';
import secondsToHms from 'src/filters/secondsToHms';

const query = gql`
query {
  individualStatistic {
    loggedDuration
    readyStatusDuration
    notReadyStatusDuration
    processedActivitiesCount
    averageFrt
    averageRt
    maxRt
  }
}`;

function parse(item) {
  let statistics = {
    T_LOGGED_DURATION: secondsToHms(item.loggedDuration),
    T_READY_STATUS_DURATION: secondsToHms(item.readyStatusDuration),
    T_NOT_READY_STATUS_DURATION: secondsToHms(item.notReadyStatusDuration),
    T_PROCESSED_ACTIVITIES_COUNT: item.processedActivitiesCount,
    T_AVERAGE_FRT: secondsToHms(item.averageFrt),
    T_AVERAGE_RT: secondsToHms(item.averageRt),
    T_MAX_RT: secondsToHms(item.maxRt),
  };
  statistics = Object.entries(statistics);
  statistics[statistics.length - 3].push('T_A1RTo_DEFINITION');
  statistics[statistics.length - 2].push('T_ART_TITLE');
  statistics[statistics.length - 1].push('T_MaxRT_DEFINITION');
  return statistics;
}

export default function getIndividualStatistic() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parse(res.data.individualStatistic));
}
